module.exports = __webpack_public_path__ + "media/packs/images/flags/CM-e8de36fd44d4d007e695629e67f0e49e.svg";